import { render, staticRenderFns } from "./PublishHistory.vue?vue&type=template&id=b4b185c6&scoped=true&"
import script from "./PublishHistory.vue?vue&type=script&lang=js&"
export * from "./PublishHistory.vue?vue&type=script&lang=js&"
import style0 from "./PublishHistory.vue?vue&type=style&index=0&id=b4b185c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4b185c6",
  null
  
)

export default component.exports